import React, { useState } from "react";
import Sidebar from "../../Component/Sidebar";
import { Button } from "antd";
import IMAGES from "../../constants/images";
import EventForm from "../../Component/EventForm";

export default function Index() {
  const [collapsed, setCollapsed] = useState(false);
  const [selectedRows, setSelectedRows] = useState([]);

  return (
    <div className="flex gap-2 bg-[#F8FAFC] min-h-screen mt-[80px]">
      <div
        className={`hidden lg:flex ${collapsed ? "w-[64px]" : "w-[272px]"} fixed top-0 left-0 h-[calc(100vh/var(--app-zoom))] z-20`}
      >
        <Sidebar collapsed={collapsed} setCollapsed={setCollapsed} />
      </div>
      <div
        className={`flex-1 min-w-0 bg-[#F8FAFC] pt-2 px-2 pb-8 transition-all duration-300 ${collapsed ? "lg:ml-[64px]" : "lg:ml-[272px]"
          }`}
      >
        <div className="p-4 md:p-6 bg-[#FFFFFF] rounded-2xl">
          <EventForm />
        </div>
      </div>
    </div>
  );
}
